module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/flow-arrow_sp-2c5f6c18a223cabccc35a7c8274174ed.png";